module.exports = __webpack_public_path__ + "media/images/emblems/Hermance-coat_of_arms-af439712ca3b5c2a4463cb9bccf73337.svg";